export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.ef8d332e.png";